export default "__VITE_ASSET__BX9nD5kg__"